import { LANG_STORAGE_KEY } from '@/shared/i18n/detect';

// Прямая работа с document.cookie без js-cookie — для прозрачной отладки.
// Воспроизводит auth-схему AngularJS-кабинета (auth_key + auth_user_id + auth_2af, 2 года, path=/, httpOnly=false).

const AUTH_KEY = 'auth_key';
const AUTH_USER_ID = 'auth_user_id';
const AUTH_2AF = 'auth_2af';

const TWO_YEARS_SECONDS = 60 * 60 * 24 * 365 * 2;

function readCookie(name: string): string | null {
  const prefix = `${name}=`;
  for (const part of document.cookie.split(';')) {
    const trimmed = part.trim();
    if (trimmed.startsWith(prefix)) {
      return decodeURIComponent(trimmed.slice(prefix.length));
    }
  }
  return null;
}

function writeCookie(name: string, value: string) {
  const encoded = encodeURIComponent(value);
  document.cookie = `${name}=${encoded}; path=/; max-age=${TWO_YEARS_SECONDS}; SameSite=Lax`;
}

function deleteCookie(name: string) {
  document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax`;
}

export const authCookies = {
  getAuthKey: () => readCookie(AUTH_KEY),
  getUserId: () => {
    const raw = readCookie(AUTH_USER_ID);
    if (!raw) return null;
    const id = parseInt(raw, 10);
    return Number.isInteger(id) ? id : null;
  },
  get2fa: () => readCookie(AUTH_2AF),

  setAuthKey: (key: string) => writeCookie(AUTH_KEY, key),
  setUserId: (id: number) => writeCookie(AUTH_USER_ID, String(id)),
  set2fa: (passed: boolean) => writeCookie(AUTH_2AF, passed ? '1' : '0'),

  clear: () => {
    deleteCookie(AUTH_KEY);
    deleteCookie(AUTH_USER_ID);
    deleteCookie(AUTH_2AF);
  },

  hasFullAuth: () => Boolean(readCookie(AUTH_KEY) && readCookie(AUTH_2AF)),
};

export const LANG_COOKIE = 'NG_TRANSLATE_LANG_KEY';

// Значение для параметра `lang-id`, который client.ts кладёт в каждый запрос.
// Писать эту cookie — обязанность shared/i18n/persist.ts (там же localStorage и
// <html lang>); здесь только чтение, поэтому источники перебираем в порядке
// надёжности: cookie → localStorage (канонический ключ, общий с лендингом) →
// атрибут документа.
export function getLangId(): string {
  const raw = readCookie(LANG_COOKIE);
  if (raw) return raw.replace(/"/g, '');

  try {
    const stored = localStorage.getItem(LANG_STORAGE_KEY);
    if (stored) return stored;
  } catch {
    // Запрещённые site data — остаётся атрибут документа.
  }

  return document.documentElement.lang || 'ru';
}
